import React from "react";
import styles from "./StartScreen.module.css";
import { Link, Redirect } from "react-router-dom";
import { endpoint, GAME_LAUNCHER, staticGameId } from "../../api-contants";

function StartScreen(props) {
  const competition = props.competition;

  let gameId = staticGameId;
  if(competition && competition.template && competition.template.gameId) {
    gameId = competition.template.gameId;
  } 

  const operatorId = props.currentOperator.id;
  const screenName = localStorage.getItem("screenname");

  let currency = "EUR";
  if(props.currentOperator.currency && props.currentOperator.currency.length > 0) {
      currency = props.currentOperator.currency;
  }

  if (!screenName) {
    return <Redirect to={(props.currentOperator.id === 9990110 || props.currentOperator.id === 7770110)?`/changeuser`:`/${props.currentOperator.name}/changeuser`} />;
  }

  function redirectTo() {
    const isMobile = window.matchMedia("only screen and (max-width: 760px)")
      .matches;
    const clientType = isMobile ? "html5" : "flash";
    const device = isMobile ? "mobile" : "desktop";

    let url = `${GAME_LAUNCHER}?gameid=${gameId}&operatorid=${operatorId}`;
    url += "&token=" + screenName;
    url += "&extension=screenname:" + screenName
    url += "&device=" + device;
    url += "&mode=real";
    url += "&language=en_gb";
    url += "&currency=" + currency;
    url += "&jurisdiction=NA";
    url += `&lobbyurl=${endpoint().locationSchema}${endpoint().location}`;

    if (clientType === "html5") {
      url += "&clienttype=" + clientType;
    }

    return url;
  };

  return (
    <div className={`${styles.startscreencontainer}`}>
      <div
        className={`${styles.startscreenImage}`}
        style={{
          backgroundImage: `url(${require(`./../../img/Portrait-${gameId && typeof gameId === "number" ? gameId : "Default"}.jpg`)}`
        }}
      >
        <div className={styles.spacer}></div>
        <div className={styles.menu}>
          <div className={styles.main}>
            <button
              onClick={() => window.open(redirectTo(), '_self')}
              className={`${styles.btn}`}
            >
              PLAY
            </button>

            {competition? (<Link
              to={(props.currentOperator.id === 9990110 || props.currentOperator.id === 7770110)?`/leaderboard`:`/${props.currentOperator.name}/leaderboard`}
              className={`${styles.btn}`}
            >
              LEADERBOARD
            </Link>): (<Link
              onClick={() => window.open('https://www.elk-studios.com/bompers-x-iter-operator-contest/', '_blank')}
              className={`${styles.btn}`}
            >
              LEADERBOARD
            </Link>)}
            <Link
              to={(props.currentOperator.id === 9990110 || props.currentOperator.id === 7770110)?`/changeuser`:`/${props.currentOperator.name}/changeuser`}
              className={`${styles.btn}`}>
              LOGOUT
            </Link>
            <div className={styles.currentName}>{screenName}</div>
          </div>
          
        </div>
      </div>
    </div>
  );
}
export default StartScreen;